import {useEffect, useState} from "react";

export const useObtenerAlto = ({elementoRef}) => {

    const [alto, setAlto] = useState(0);

    useEffect(() => {
        // Si no hay elemento asignado a la ref, no hacemos nada
        if (!elementoRef.current) return;

        const elemento = elementoRef.current;

        // Creamos el ResizeObserver
        const observador = new ResizeObserver((entries) => {
            if (!entries || entries.length === 0) return;

            const { width, height } = entries[0].contentRect;

            // Actualizamos el estado con el nuevo alto y ancho redondeados
            setAlto(Math.round(height));
        });

        // Empezamos a observar el elemento
        observador.observe(elemento);

        // 🧹 FUNCIÓN DE LIMPIEZA (Cleanup)
        // Se ejecuta cuando el componente se desmonta o cambia
        return () => {
            observador.unobserve(elemento);
            observador.disconnect();
        };
    }, []); // Array vacío para que solo se ejecute al montar y desmontar

    return {
        alto
    }
}